import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MediaTypeOption, MediaRatioOption, ImageModel } from '../../../common/models';

@Component({
    selector: 'lib-question-option',
    templateUrl: './question-option.component.html',
    styleUrls: ['./question-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class QuestionOptionComponent {
  @Input() public theme: string;
  @Input() public index: number;
  @Input() public text: string;
  @Input() public mediaImage: ImageModel;
  @Input() public canEdit = false;
  @Input() public isTranslation = false;

  @Input() public mediaType = MediaTypeOption.NONE;
  @Input() public mediaRatio = MediaRatioOption.SQUARE;


  @Input() public active = false;
  @Input() public visited = false;
  @Input() public numeric = false;

  @Output() edit: EventEmitter<void> = new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();

  @HostBinding('class')
  get hostClasses(): string {
    return `${this.mediaType} ${this.active ? 'active' : ''} ${this.theme ?? ''}`.trim();
  }

  public readonly mediaTypes: typeof MediaTypeOption = MediaTypeOption;

  constructor() { }
}
